import { render, staticRenderFns } from "./ProductsModule.vue?vue&type=template&id=f57b4490&scoped=true"
import script from "./ProductsModule.vue?vue&type=script&lang=js"
export * from "./ProductsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57b4490",
  null
  
)

export default component.exports